import React from 'react';
import Icon from '../../../components/AppIcon';

const EventDetails = ({ event }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <h3 className="text-lg font-semibold mb-4 flex items-center space-x-2">
        <Icon name="FileText" size={20} />
        <span>Event Details</span>
      </h3>
      <div className="prose prose-sm max-w-none">
        <p className="text-muted-foreground leading-relaxed">
          {event?.description || 'No description available for this event.'}
        </p>
      </div>
      {/* Learning Objectives */}
      <div className="mt-6">
        <h4 className="font-medium mb-3 flex items-center space-x-2">
          <Icon name="Target" size={18} />
          <span>What You'll Learn</span>
        </h4>
        <div className="bg-muted/30 rounded-lg p-4">
          <ul className="space-y-2 text-sm text-muted-foreground">
            <li className="flex items-start space-x-2">
              <Icon name="Check" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
              <span>Gain insights into the latest smart cities innovations and technologies</span>
            </li>
            <li className="flex items-start space-x-2">
              <Icon name="Check" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
              <span>Network with industry experts and fellow professionals</span>
            </li>
            <li className="flex items-start space-x-2">
              <Icon name="Check" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
              <span>Discover practical solutions for urban challenges</span>
            </li>
            <li className="flex items-start space-x-2">
              <Icon name="Check" size={16} className="text-green-600 mt-0.5 flex-shrink-0" />
              <span>Explore collaboration opportunities and partnerships</span>
            </li>
          </ul>
        </div>
      </div>
      {/* Prerequisites */}
      <div className="mt-6">
        <h4 className="font-medium mb-3 flex items-center space-x-2">
          <Icon name="BookOpen" size={18} />
          <span>Prerequisites</span>
        </h4>
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
          <ul className="space-y-1 text-sm text-blue-800">
            <li>• Basic understanding of urban planning concepts</li>
            <li>• Interest in technology and innovation</li>
            <li>• No prior experience with smart cities required</li>
          </ul>
        </div>
      </div>
      {/* Who Should Attend */}
      <div className="mt-6">
        <h4 className="font-medium mb-3 flex items-center space-x-2">
          <Icon name="Users" size={18} />
          <span>Who Should Attend</span>
        </h4>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {[
            'City Officials & Planners',
            'Technology Professionals',
            'Entrepreneurs & Startups',
            'Students & Researchers',
            'Community Leaders',
            'Corporate Partners'
          ]?.map((audience, index) => (
            <div key={index} className="flex items-center space-x-2 text-sm">
              <Icon name="User" size={14} className="text-primary" />
              <span>{audience}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default EventDetails;